import PageContainerBlank from '../../components/PageContainer/PageContainerBlank.js';
import PageEndBlank from '../../components/PageContainer/PageEndBlank.js';
import PrayerInstructions from '../../components/PrayerInstructions/PrayerInstructions.js';
import FlexColumn from '../../components/FlexColumn/FlexColumn.js';
import FirstSorrow from '../../components/Mysteries/RosarySorrows/FirstSorrow.js';
import SecondSorrow from '../../components/Mysteries/RosarySorrows/SecondSorrow.js';
import ThirdSorrow from '../../components/Mysteries/RosarySorrows/ThirdSorrow.js';
import FourthSorrow from '../../components/Mysteries/RosarySorrows/FourthSorrow.js';
import FifthSorrow from '../../components/Mysteries/RosarySorrows/FifthSorrow.js';
import SixthSorrow from '../../components/Mysteries/RosarySorrows/SixthSorrow.js';
import SeventhSorrow from '../../components/Mysteries/RosarySorrows/SeventhSorrow.js';
import { MYSTERY_GAP, MOBILE_MYSTERY_GAP } from '../../utils/Constants.js';

const SevenSorrows = () => {
	const baseInstructions = [
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (
			<div>
				<p>My God, I offer You this Rosary for Your glory, so I can honor your Holy Mother, the Blessed Virgin, so I can share and meditate upon her suffering. I humbly beg you to give me true repentance for all my sins. Give me wisdom and humility, so that I may receive all the indulgences contained in this prayer.</p>
			</div>
		)},
		{imageKey: "", title: "Act of Contrition", descriptionElements: (
			<div>
				<p>O my God, I am heartily sorry for having offended Thee; I detest all my sins because I dread the loss of heaven and the pains of hell, but most of all because they offend Thee, my God, Who art all good and deserving of all my love. I firmly resolve, with the help of Thy grace, to sin no more and to avoid the near occasions of sin.</p>
				<p>Amen.</p>
			</div>
		)},
		{imageKey: "smallbead", title: "Three Hail Marys", descriptionElements: (
			<div>
				<em className='highlight'>(These three prayers are said at the beginning or end of the decades in honor of the tears of Our Sorrowful Mother)</em>
			</div>
		), falseEnding: true},
	];
	const sorrowInstructions = [
		{imageKey: "largebead", title: "Announce the Sorrow", descriptionElements: (
			<div>
				<p>The Seven Sorrows are listed below, one after the other.</p>
			</div>
		)},
		{imageKey: "", title: "Our Father", descriptionElements: (
			<div></div>
		)},
		{imageKey: "smallbead", title: "Hail Mary", descriptionElements: (
			<div>
				<em className='highlight'>(Pray for each of the 7 beads in the decade)</em>
			</div>
		)},
		{imageKey: "", title: "Invocation of Your Choice", descriptionElements: (
			<div>
				<p>Holy Mother, hear my prayers, and renew in my heart each wound of Jesus my Savior.</p>
				<p>Most Merciful Mother, remind us always about the Sorrows of your Son, Jesus.</p>
				<p>Mother of love, Mother of sorrows and of mercy, pray for us.</p>
			</div>
		), falseEnding: true},
	];
	const closingInstructions = [
		{imageKey: "medallion", title: "Closing Prayers", descriptionElements: (
			<div>
				<p>O Mary, you truly became the Queen of all martyrs as these seven bitter swords of sorrow pierced your Immaculate Heart! By the merits of your tearful distress obtain for us and for all sinners the graces of perfect contrition and conversion. Help us always, dear Mother, to imitate you by taking up our crosses and following Jesus with limitless love and generosity.</p>
				<p>Amen.</p>
				<p>Mary, who was conceived without sin and who suffered for us, pray for us.<br /><em className='highlight'>(Pray this three times)</em></p>
			</div>
		)},
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (
			<div></div>
		)},
	];
	return (
		<div className='justify'>
			<PageContainerBlank />

			<h1>Rosary of the Seven Sorrows</h1>
			<p className='centered'>The Rosary of the Seven Sorrows is prayed on a chaplet with 7 sets of 7 beads. This devotion has its origins in the thirteenth century with St. Bridget of Sweden and was popularized by Our Lady of Kibeho.</p>
			<br />

			<PrayerInstructions instructions={baseInstructions} />
			<br />

			<h2>For each decade:</h2>

			<PrayerInstructions instructions={sorrowInstructions} />
			<br />

			<div>
				<FlexColumn pcGap={MYSTERY_GAP} mobileGap={MOBILE_MYSTERY_GAP}>
					<FirstSorrow />
					<SecondSorrow />
					<ThirdSorrow />
					<FourthSorrow />
					<FifthSorrow />
					<SixthSorrow />
					<SeventhSorrow />
				</FlexColumn>
			</div>
			<br />

			<PrayerInstructions instructions={closingInstructions} />

			<PageEndBlank />
		</div>
	);
};

export default SevenSorrows;